$(document).ready(function() {
    initPaymentMandates();
});

function initPaymentMandates() {
    setupRevokeModal();
}

function setupRevokeModal() {
    const $revokeModal = $('#revokeModal');
    if (!$revokeModal.length) return;

    $revokeModal.on('show.bs.modal', function(event) {
        const button = event.relatedTarget;
        const mandateId = $(button).data('mandate-id');
        const mandateName = $(button).data('mandate-name');

        $('#mandateName').text(mandateName);

        const $form = $('#revokeForm');
        const url = `/users/payment_mandates/${mandateId}`;
        $form.attr('action', url);
    });

    $('#revokeForm').on('submit', function() {
        const $submitButton = $('#confirmRevoke');
        const originalText = $submitButton.html();
        const $container = $('[data-payment-mandates]');
        const processingText = $container.data('processing-text') || 'Processing...';

        $submitButton.prop('disabled', true);
        $submitButton.html(`<i class="fas fa-spinner fa-spin me-1"></i>${processingText}`);

        setTimeout(function() {
            $submitButton.prop('disabled', false);
            $submitButton.html(originalText);
        }, 10000);
    });
}
